"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RicercaDashboardDtoToJSON = exports.RicercaDashboardDtoFromJSONTyped = exports.RicercaDashboardDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RicercaDashboardDtoFromJSON(json) {
    return RicercaDashboardDtoFromJSONTyped(json, false);
}
exports.RicercaDashboardDtoFromJSON = RicercaDashboardDtoFromJSON;
function RicercaDashboardDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dataInizio': !runtime_1.exists(json, 'dataInizio') ? undefined : (json['dataInizio'] === null ? null : new Date(json['dataInizio'])),
        'dataFine': !runtime_1.exists(json, 'dataFine') ? undefined : (json['dataFine'] === null ? null : new Date(json['dataFine'])),
        'statocertificazione': !runtime_1.exists(json, 'statocertificazione') ? undefined : _1.StatoCertificazioneTypeFromJSON(json['statocertificazione']),
        'modalitacertificazione': !runtime_1.exists(json, 'modalitacertificazione') ? undefined : _1.ModalitaCertificazioneTypeFromJSON(json['modalitacertificazione']),
        'filialeNdg': !runtime_1.exists(json, 'filialeNdg') ? undefined : json['filialeNdg'],
        'tipoDashboard': !runtime_1.exists(json, 'tipoDashboard') ? undefined : _1.TipoDashboardFromJSON(json['tipoDashboard']),
        'idLotto': !runtime_1.exists(json, 'idLotto') ? undefined : json['idLotto'],
    };
}
exports.RicercaDashboardDtoFromJSONTyped = RicercaDashboardDtoFromJSONTyped;
function RicercaDashboardDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dataInizio': value.dataInizio === undefined ? undefined : (value.dataInizio === null ? null : value.dataInizio.toISOString()),
        'dataFine': value.dataFine === undefined ? undefined : (value.dataFine === null ? null : value.dataFine.toISOString()),
        'statocertificazione': _1.StatoCertificazioneTypeToJSON(value.statocertificazione),
        'modalitacertificazione': _1.ModalitaCertificazioneTypeToJSON(value.modalitacertificazione),
        'filialeNdg': value.filialeNdg,
        'tipoDashboard': _1.TipoDashboardToJSON(value.tipoDashboard),
        'idLotto': value.idLotto,
    };
}
exports.RicercaDashboardDtoToJSON = RicercaDashboardDtoToJSON;
